import React, { useState } from "react";
import styles from "../../assets/styles/Charge/Charge.module.scss";
import { AppPage, MimaButton, PageLoader, Searchbar } from "../../components";
import MimaOptionMenu from "../../components/OptionMenu/";
import { AnimatePresence } from "framer-motion";
import moment from "moment";
import {
  AddChargeContainer,
  DeleteChargeContainer,
  EditChargeContainer,
} from "../../containers";

const Charge = ({
  closeModal,
  loading,
  handleAddCharge,
  handleEditCharge,
  handleDeleteCharge,
  addChargeModal,
  editChargeModal,
  deleteChargeModal,
  chargeList,
}) => {
  const [filteredCharges, setFilteredCharges] = useState([]);
  const [data, setData] = useState({});

  return (
    <AppPage pageTitle="Charges">
      {loading ? (
        <PageLoader title="while we load your information" />
      ) : (
        <div style={{ marginTop: "2rem" }}>
          <div className={styles.searchMidle}>
            <Searchbar
              variant="wide"
              placeholder="Search"
              input={chargeList}
              output={setFilteredCharges}
              handleFilter={(item, searchQuery) => {
                return (
                  item?.name.toLowerCase()?.includes(searchQuery) ||
                  String(item.value).toLowerCase()?.includes(searchQuery) ||
                  item?.type.toLowerCase()?.includes(searchQuery)
                );
              }}
              height={5}
            />
            <MimaButton
              title="Add Charge"
              width={30}
              onClick={handleAddCharge}
            />
          </div>

          <div className="whiteTable">
            <table>
              <thead>
                <tr>
                  <th>Date Created</th>
                  <th>Charge For</th>
                  <th>Charge Name</th>
                  <th>Type</th>
                  <th>Value</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredCharges.map((item) => (
                  <tr key={item}>
                    {item.status === true ? (
                      <>
                        <td>
                          {moment(item.createdAt).format("DD/MM/YYYY HH:mm a")}
                        </td>
                        <td>
                          {item.businesses.length > 0
                            ? "Specific Businesses"
                            : "General"}
                        </td>
                        <td>{item.name}</td>
                        <td>{item.type}</td>
                        <td>
                          {item.type === "Fixed"
                            ? `NGN${item.value}`
                            : `${item.value}%`}
                        </td>
                        <td>
                          <div className="tableAction__text">
                            <MimaOptionMenu
                              options={[
                                {
                                  label: "Edit",
                                  value: "Edit",
                                },
                                {
                                  label: "Delete",
                                  value: "Delete",
                                },
                              ]}
                              onOptionSelected={(option) => {
                                setData(item);
                                if (option.value === "Edit") {
                                  handleEditCharge(item._id);
                                } else if (option.value === "Delete") {
                                  handleDeleteCharge(item._id);
                                }
                              }}
                            />
                          </div>
                        </td>
                      </>
                    ) : null}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {(addChargeModal || editChargeModal || deleteChargeModal) && (
            <di className="modal">
              <AnimatePresence>
                {addChargeModal && (
                  <AddChargeContainer closeModal={closeModal} />
                )}

                {editChargeModal && (
                  <EditChargeContainer data={data} closeModal={closeModal} />
                )}

                {deleteChargeModal && (
                  <DeleteChargeContainer data={data} closeModal={closeModal} />
                )}
              </AnimatePresence>
            </di>
          )}
        </div>
      )}
    </AppPage>
  );
};
export default Charge;
